module.exports = __webpack_public_path__ + "img/UN.a32ff305.svg";